document.addEventListener('DOMContentLoaded', function() {
  var btn = document.getElementById('custom-checkout-btn');
  if (!btn) return;

  btn.addEventListener('click', function() {
    var titleField = document.getElementById('cart-attr-title');
    var orgField = document.getElementById('cart-attr-org');
    var refField = document.getElementById('cart-attr-referral');

    // Reset border colors
    titleField.style.borderColor = '';
    orgField.style.borderColor = '';
    refField.style.borderColor = '';

    if (!titleField.value.trim() || !orgField.value.trim() || !refField.value.trim()) {
      if (!titleField.value.trim()) titleField.style.borderColor = 'red';
      if (!orgField.value.trim()) orgField.style.borderColor = 'red';
      if (!refField.value.trim()) refField.style.borderColor = 'red';
      alert('Please fill out all three fields before proceeding to checkout.');
      return;
    }

    // Save attributes via AJAX
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          Title: titleField.value.trim(),
          Organization: orgField.value.trim(),
          Referral: refField.value.trim()
        }
      })
    }).then(function() {
      window.location.href = '/checkout';
    });
  });
});
